<template>
  <div class="container">
    <Loading v-show="pageLoading" />
    <div class="width_wrap">
      <MypageSidebar />
      <div class="body_content sub personal-order-project-detail">
        <div style="height: auto">
          <n-space vertical>
            <NCard
              class="main-card"
              style="
                margin-top: 5px;
                margin-left: 5px;
                border: 0px;
                min-width: 800px;
                max-width: 1000px;
              "
            >
              <n-space
                item-style="display: flex;"
                align="center"
                justify="space-between"
              >
                <div style="font-size: 20px; font-weight: bold">
                  진단 검사 정보
                </div>
                <n-button @click="refreshData" type="tertiary" size="small">
                  <template #icon>
                    <n-icon>
                      <RefreshIcon />
                    </n-icon>
                  </template>
                  새로고침
                </n-button>
              </n-space>
              <div class="content_delimiter_line"></div>
              <div
                v-if="pageLoading"
                class="loading-indicator"
                style="text-align: center; padding: 20px"
              >
                진단 정보를 불러오는 중...
              </div>
              <div
                v-else-if="
                  !orderProjectEntries || orderProjectEntries.length === 0
                "
                style="text-align: center; padding: 20px; color: #888"
              >
                진단 정보를 불러오지 못했습니다.
              </div>

              <div v-else class="split-view-container">
                <!-- 좌측: 학급/학과 목록 -->
                <div class="left-class-list">
                  <div class="list-title">진단 그룹</div>
                  <div v-for="group in groupedProjectEntries" :key="group.type">
                    <h5 class="list-subtitle">{{ group.title }}</h5>
                    <ul>
                      <li
                        v-for="classItem in group.entries"
                        :key="classItem.SK"
                        :class="{
                          'list-item': true,
                          active:
                            activeClassIndex === getOriginalIndex(classItem),
                        }"
                        @click="scrollToClass(getOriginalIndex(classItem))"
                      >
                        {{ getClassItemTitle(classItem) }}
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- 우측: 상세 정보 (스크롤 가능) -->
                <div class="right-details-area">
                  <NCard
                    v-if="orderProjectEntries && orderProjectEntries.length > 0"
                    :title="
                      getClassTitle(
                        orderProjectEntries[activeClassIndex],
                        activeClassIndex
                      )
                    "
                    size="small"
                    style="
                      margin-bottom: 25px;
                      border: 1px solid #dcdfe6;
                      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.07);
                    "
                  >
                    <n-descriptions
                      v-if="orderProjectEntries[activeClassIndex]"
                      label-placement="left"
                      label-style="width: 130px;"
                      :column="2"
                      bordered
                      size="small"
                      style="margin-bottom: 15px"
                    >
                      <n-descriptions-item
                        v-if="
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.ING
                        "
                        label="검사 이름"
                      >
                        {{
                          common.getProjectName(
                            orderProjectEntries[activeClassIndex].type
                          ) || orderProjectEntries[activeClassIndex].name
                        }}
                      </n-descriptions-item>
                      <n-descriptions-item label="상태">
                        <div style="display: flex; align-items: center">
                          <span>
                            {{
                              getProjectStatusString(
                                orderProjectEntries[activeClassIndex].status
                              )
                            }}
                          </span>
                          <n-button
                            v-if="
                              orderProjectEntries[activeClassIndex].status ===
                              constant.projectStatus.PENDING
                            "
                            style="margin-left: 10px"
                            type="primary"
                            @click="
                              doOpenProject(
                                orderProjectEntries[activeClassIndex].SK
                              )
                            "
                            :disabled="isDoingJob"
                            :loading="
                              isProjectOpening[
                                orderProjectEntries[activeClassIndex].SK
                              ]
                            "
                          >
                            진단검사 실시
                          </n-button>
                        </div>
                      </n-descriptions-item>
                      <n-descriptions-item
                        v-if="
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.ING
                        "
                        label="검사 링크"
                        :span="2"
                      >
                        <a
                          :href="common.getSurveyUrl(orderProjectEntries[activeClassIndex].SK!)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="
                            orderProjectEntries[activeClassIndex]
                              .responder_uri &&
                            orderProjectEntries[activeClassIndex].status ==
                              constant.projectStatus.ING
                          "
                        >
                          {{
                            common.getSurveyUrl(
                              orderProjectEntries[activeClassIndex].SK!
                            )
                          }}
                        </a>
                        <span
                          v-else-if="
                            orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.COMPLETED
                          "
                        >
                          종료된 검사 입니다.
                        </span>
                        <span v-else style="color: red">
                          검사가 활성화 되면 링크가 표시됩니다.
                        </span>
                      </n-descriptions-item>
                      <template
                        v-if="
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.ING
                        "
                      >
                        <template
                          v-if="
                            orderProjectEntries[activeClassIndex].type ===
                              'putt_u' ||
                            orderProjectEntries[activeClassIndex].type === 'tec'
                          "
                        >
                          <n-descriptions-item :label="`전공`">
                            {{
                              orderProjectEntries[activeClassIndex].major ||
                              "N/A"
                            }}
                          </n-descriptions-item>
                          <n-descriptions-item :label="`학년`">
                            {{
                              orderProjectEntries[activeClassIndex].grade ||
                              "N/A"
                            }}
                          </n-descriptions-item>
                        </template>
                        <template v-else>
                          <n-descriptions-item :label="`학년`">
                            {{
                              orderProjectEntries[activeClassIndex].grade ||
                              "N/A"
                            }}
                          </n-descriptions-item>
                          <n-descriptions-item :label="`반`">
                            {{
                              orderProjectEntries[activeClassIndex].class ||
                              "N/A"
                            }}
                          </n-descriptions-item>
                        </template>
                      </template>
                      <template
                        v-if="
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.ING
                        "
                      >
                        <n-descriptions-item label="진단 시작일">
                          {{
                            common.getYYYMMDDStringFormat(
                              orderProjectEntries[activeClassIndex]
                                .start_target_date
                            )
                          }}
                        </n-descriptions-item>
                        <n-descriptions-item label="진단 종료일">
                          {{
                            common.getYYYMMDDStringFormat(
                              orderProjectEntries[activeClassIndex]
                                .end_target_date
                            )
                          }}
                        </n-descriptions-item>
                      </template>
                      <template
                        v-if="
                          orderProjectEntries[activeClassIndex]
                            .teacher_report_file
                        "
                      >
                        <n-descriptions-item label="담임용 리포트" :span="2">
                          <n-button
                            type="primary"
                            @click="
                              downloadTeacherReportFile(
                                orderProjectEntries[activeClassIndex]
                              )
                            "
                          >
                            다운로드
                          </n-button>
                        </n-descriptions-item>
                      </template>
                      <template v-else>
                        <n-descriptions-item
                          label="담임용 결과리포트"
                          :span="2"
                        >
                          N/A
                        </n-descriptions-item>
                      </template>
                      <n-descriptions-item label="담당자" :span="2">
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <span v-if="orderProjectEntries[activeClassIndex].email">
                            {{ orderProjectEntries[activeClassIndex].manager_name || '이름 없음' }} ({{ orderProjectEntries[activeClassIndex].email }})
                            <span v-if="orderProjectEntries[activeClassIndex].manager_role || orderProjectEntries[activeClassIndex].manager_position">
                              / {{ orderProjectEntries[activeClassIndex].manager_role || '-' }} / {{ orderProjectEntries[activeClassIndex].manager_position || '-' }}
                            </span>
                          </span>
                          <span v-else style="color: #d03050; font-weight: 600;">지정된 담당자가 없습니다.</span>
                          
                          <n-button 
                            v-if="isOrgAdmin" 
                            size="tiny" 
                            type="info" 
                            ghost 
                            @click="openManagerSelectModalForDetail"
                          >
                            담당자 변경
                          </n-button>
                        </div>
                      </n-descriptions-item>
                      <n-descriptions-item
                        v-if="
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries[activeClassIndex].status ==
                            constant.projectStatus.ING
                        "
                        label="진단검사분석요청"
                        :span="2"
                      >
                        <div
                          style="
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            align-items: center;
                          "
                        >
                          <n-tooltip
                            v-if="
                              orderProjectEntries[activeClassIndex].type !=
                              'tec'
                            "
                            trigger="hover"
                          >
                            <template #trigger>
                              <n-button
                                size="small"
                                :disabled="isDoingJob || orderProjectEntries[activeClassIndex].is_teacher_report_generating"
                                :loading="
                                  isTeacherReporting[
                                    orderProjectEntries[activeClassIndex].SK
                                  ] || orderProjectEntries[activeClassIndex].is_teacher_report_generating
                                "
                                type="primary"
                                @click="
                                  doRequestTeacherReport(
                                    orderProjectEntries[activeClassIndex].SK
                                  )
                                "
                              >
                                {{ orderProjectEntries[activeClassIndex].is_teacher_report_generating ? '레포트 생성 중...' : '결과리포트_담임용 생성요청' }}
                              </n-button>
                            </template>
                            {{
                              getClassTitle(
                                orderProjectEntries[activeClassIndex],
                                activeClassIndex
                              )
                            }}의 학생목록의 결과리포트를 종합하는 담임용 리포트
                            생성을 요청합니다.
                          </n-tooltip>
                          <n-tooltip trigger="hover">
                            <template #trigger>
                              <n-button
                                size="small"
                                :disabled="isDoingJob"
                                :loading="
                                  isStudentReporting[
                                    orderProjectEntries[activeClassIndex].SK
                                  ]
                                "
                                type="primary"
                                @click="
                                  doRequestExamineeReport(
                                    orderProjectEntries[activeClassIndex].SK
                                  )
                                "
                              >
                                결과리포트_학생용 생성요청
                              </n-button>
                            </template>
                            {{
                              getClassTitle(
                                orderProjectEntries[activeClassIndex],
                                activeClassIndex
                              )
                            }}의 모든 학생들에 대해서 개별 리포트 생성을
                            요청합니다.
                          </n-tooltip>
                          <n-tooltip trigger="hover">
                            <template #trigger>
                              <n-button
                                size="small"
                                :disabled="isDoingJob"
                                :loading="
                                  isProjectClosing[
                                    orderProjectEntries[activeClassIndex].SK
                                  ]
                                "
                                type="primary"
                                @click="
                                  doRequestProjectClose(
                                    orderProjectEntries[activeClassIndex].SK
                                  )
                                "
                              >
                                검사 종료 및 결과리포트_학생용 전송 요청
                              </n-button>
                            </template>
                            {{
                              getClassTitle(
                                orderProjectEntries[activeClassIndex],
                                activeClassIndex
                              )
                            }}의 검사를 종료하고, 검사결과를 개별 학생들에게
                            전송하도록 요청합니다.
                          </n-tooltip>
                        </div>
                      </n-descriptions-item>
                    </n-descriptions>

                    <div
                      class="examinee-creation-section"
                      v-if="
                        orderProjectEntries[activeClassIndex].examinees &&
                        orderProjectEntries[activeClassIndex].examinees.length >
                          0
                      "
                    >
                      <h5 class="examinee-section-title">학생 목록</h5>
                      <ExamineeTable
                        :examinees="
                          orderProjectEntries[activeClassIndex].examinees
                        "
                        :status="orderProjectEntries[activeClassIndex].status"
                        :classType="orderProjectEntries[activeClassIndex].type"
                        :project="orderProjectEntries[activeClassIndex]"
                      />

                    </div>
                    <div
                      v-else
                      style="margin-top: 10px; text-align: center; color: #888"
                    >
                      등록된 학생 정보가 없습니다.
                    </div>
                  </NCard>
                </div>
              </div>
            </NCard>
            <!-- 최하단 버튼 영역 -->
            <div
              style="
                margin-top: 30px;
                text-align: right;
                margin-left: 80px;
                min-width: 800px;
                max-width: 1000px;
              "
            >
              <n-button type="primary" @click="handleCancel">
                목록으로
              </n-button>
            </div>
          </n-space>
        </div>
      </div>
    </div>
    <!-- 담당자 지정 모달 -->
    <n-modal
      v-model:show="isManagerModalOpen"
      preset="card"
      title="담당자 지정"
      style="width: 700px; max-width: 90%"
      :bordered="false"
    >
      <n-space vertical :size="12">
        <n-space align="center" justify="space-between">
          <n-input
            v-model:value="memberSearchQuery"
            placeholder="이름 또는 이메일 검색"
            clearable
            style="width: 250px"
            :disabled="isUpdatingManager"
          />
          <n-checkbox v-model:checked="isIncludeAdmin" :disabled="isUpdatingManager">
            관리자 포함
          </n-checkbox>
        </n-space>
        <n-data-table
          :loading="loadingMembers || isUpdatingManager"
          :columns="memberTableColumns"
          :data="filteredOrgMembers"
          :pagination="{ pageSize: 5 }"
          :row-key="(row) => row.SK"
        />
      </n-space>
    </n-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed, onUnmounted } from "vue";
import MypageSidebar from "@/views/member/MypageSidebar.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter, useRoute } from "vue-router";
import {
  NSpace,
  NCard,
  NButton,
  NDescriptions,
  NDescriptionsItem,
  NDataTable,
  DataTableColumns,
  useNotification,
  useMessage,
  useDialog,
  NIcon,
  NModal,
  NCheckbox,
  NInput,
  NTag,
  NTooltip,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import {
  getCallable,
  getCallableOption,
  getRequestEndpoint,
} from "@/config/env";
import * as common from "@/assets/common/common";
import { getAuth } from "firebase/auth";
import * as constant from "@/constants/constant";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { RefreshOutline as RefreshIcon } from "@vicons/ionicons5";
import { getProjectStatusString } from "@/composables/useOrderForm";
import { useDownload } from "@/composables/useDownload";
const { downloadReportFile } = useDownload();

import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();

import { useAuth } from "@/composables/useAuth";
const { isOrgAdmin } = useAuth();

const router = useRouter();
const route = useRoute();
const notification = useNotification();
const message = useMessage();
const dialog = useDialog();
const auth = getAuth();

const pageLoading = ref(true);
const isDoingJob = ref(false);
const isTeacherReporting = ref<{ [key: string]: boolean }>({});
const isStudentReporting = ref<{ [key: string]: boolean }>({});
const isProjectOpening = ref<{ [key: string]: boolean }>({});
const isProjectClosing = ref<{ [key: string]: boolean }>({});
const isDownloadingStudentReport = ref<{ [key: string]: boolean }>({});
const isSendingStudentEmail = ref<{ [key: string]: boolean }>({});

const order = ref<Order>();
const activeClassIndex = ref(0); // 현재 활성화된 학급 목록 항목 인덱스
const orderProjectEntries = ref<Project[]>(); // Changed to Project[] for clarity

const isManagerModalOpen = ref(false);
const orgMembers = ref<any[]>([]);
const loadingMembers = ref(false);
const memberSearchQuery = ref("");
const isIncludeAdmin = ref(false);
const isUpdatingManager = ref(false);

interface ExamineeTableProps {
  examinees: Examinee[];
  status?: string;
  classType?: string;
  project?: Project;
}

const getOrderProjectsCallable = getCallable(
  "getOrderProjectsContainsExamninees"
);
const openOneProjectCallable = getCallable("openOneProject");
const requestProjectReportGenerationCallable = getCallableOption(
  "requestProjectReportGeneration"
);
const requestTeacherReportGenerationCallable = getCallableOption(
  "requestTeacherReportGeneration"
);
const closeOneProjectCallable = getCallable("closeOneProject");
const getProjectCallable = getCallable("getProject");
const getProjectContainsExamnineesCallable = getCallable("getProjectContainsExamninees");
const updateProjectManagerCallable = getCallable("updateProjectManager");
const getOrgMembersCallable = getCallable("getOrgMembers");
const sendExamineeReportEmailCallable = getCallable("sendExamineeReportEmail");
const updateExamineeEmailCallable = getCallable("updateExamineeEmail");


const filteredOrgMembers = computed(() => {
  return orgMembers.value.filter((member) => {
    // 1. 관리자 포함 여부 필터
    if (!isIncludeAdmin.value && member.type === "admin") {
      return false;
    }
    // 2. 이름 또는 이메일 검색 필터
    if (memberSearchQuery.value.trim()) {
      const q = memberSearchQuery.value.toLowerCase().trim();
      const nameMatch = member.name?.toLowerCase().includes(q);
      const emailMatch = member.email?.toLowerCase().includes(q);
      return nameMatch || emailMatch;
    }
    return true;
  });
});

const memberTableColumns = [
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "사용자";
    }
  },
  {
    title: "선택",
    key: "actions",
    render(row: any) {
      return h(
        NButton,
        {
          size: "small",
          type: "info",
          disabled: isUpdatingManager.value,
          onClick: () => selectManager(row),
        },
        { default: () => "선택" }
      );
    }
  }
];

async function fetchSingleProjectDetails(projectSK: string, index: number, silent = false) {
  if (!silent) {
    pageLoading.value = true;
  }
  try {
    const projectResult = await getProjectCallable({ SK: projectSK });
    const examineesResult = await getProjectContainsExamnineesCallable({ SK: projectSK });

    if (common.evalFunctionResult(projectResult) && common.evalFunctionResult(examineesResult)) {
      const projectData = common.getItemFromFunctionResult(projectResult) as Project;
      const examineesData = common.getItemListFromFunctionResult(examineesResult) as Examinee[];
      if (orderProjectEntries.value && orderProjectEntries.value[index]) {
        orderProjectEntries.value[index] = {
          ...projectData,
          examinees: examineesData,
        };
      }
    } else {
      console.error("진단 정보 개별 로딩 실패:", common.getResultError(projectResult) || common.getResultError(examineesResult));
      if (!silent) {
        notification.error({
          title: "로딩 실패",
          description: "진단 상세 정보를 불러오는 중 오류가 발생했습니다.",
          duration: 3000,
        });
      }
    }
  } catch (error: any) {
    console.error("진단 정보 개별 로딩 오류:", error);
    if (!silent) {
      notification.error({
        title: "로딩 실패",
        description: error || "진단 상세 정보를 불러오는 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } finally {
    if (!silent) {
      pageLoading.value = false;
    }
  }
}

async function fetchOrderProjectDetails(orderSK: string, silent = false) {
  if (!silent) {
    pageLoading.value = true;
  }
  const orderSKFromRoute = route.params.SK as string;
  if (!orderSKFromRoute) {
    pageLoading.value = false;
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // Or a default order list route
    return; // Early exit if SK is not found
  }
  try {
    const result = await getOrderProjectsCallable({ SK: orderSK });
    if (common.evalFunctionResult(result)) {
      const orderProjectData = common.getItemListFromFunctionResult(
        result
      ) as Project[];
      if (orderProjectData && orderProjectData.length > 0) {
        orderProjectEntries.value = orderProjectData;
        activeClassIndex.value = 0; // 첫 번째 항목 활성화
      } else {
        notification.warning({
          title: "정보 없음",
          description:
            "해당 진단 정보를 찾을 수 없습니다. 또는 등록된 학급/학과 정보가 없습니다.",
          duration: 3000,
        });
        orderProjectEntries.value = []; // Clear existing data if any
      }
    } else {
      console.error("견적 상세 정보 로딩 실패:", common.getResultError(result));
      notification.error({
        title: "로딩 실패",
        description:
          common.getResultError(result) ||
          "견적 정보를 불러오는 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("견적 상세 정보 로딩 실패:", error);
    notification.error({
      title: "로딩 실패",
      description: error || "견적 정보를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    pageLoading.value = false;
  }
}

let isComponentMounted = true;
let refreshInterval: any = null;

onMounted(async () => {
  isComponentMounted = true;
  const orderSKFromRoute = route.params.SK as string;
  if (!orderSKFromRoute) {
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.ORDER_LIST.NAME }); // Or a default order list route
    return;
  }
  await fetchOrderProjectDetails(orderSKFromRoute);

  if (isComponentMounted) {
    refreshInterval = setInterval(async () => {
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value]) {
        const activeProject = orderProjectEntries.value[activeClassIndex.value];
        if (activeProject && activeProject.SK) {
          await fetchSingleProjectDetails(activeProject.SK, activeClassIndex.value, true);
        }
      }
    }, 15000);
  }
});

onUnmounted(() => {
  isComponentMounted = false;
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
});

async function refreshData() {
  if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value]) {
    const activeProject = orderProjectEntries.value[activeClassIndex.value];
    if (activeProject && activeProject.SK) {
      await fetchSingleProjectDetails(activeProject.SK, activeClassIndex.value, false);
    }
  }
}

const getClassTitle = (classItem: Project, classIdx: number): string => {
  let typeName = "정보"; // 기본값
  if (classItem.type === "putt_u" || classItem.type === "tec") {
    typeName = "학과";
    // 학과명 + 학년 조합 (예: 컴퓨터공학과 1학년)
    if (classItem.major && classItem.grade)
      return `${classItem.major} ${classItem.grade}학년`;
    if (classItem.major) return `${classItem.major}`;
  } else {
    typeName = "학급";
    // 학년 + 반 조합 (예: 1학년 1반)
    if (classItem.grade && classItem.class)
      return `${classItem.grade}학년 ${classItem.class}반`;
  }
  return `${typeName} ${classIdx + 1}`;
};

const createExamineeTableColumns = (
  status: constant.orderStatus,
  classType?: string,
  project?: Project
): DataTableColumns<Examinee> => {
  const isUniversityType = classType === "putt_u" || classType === "tec";
  return [
    {
      title: "학생 정보 및 결과리포트 / 이메일 관리",
      key: "examinee_info",
      render: (row, idx) => {
        const isSent = !!row.email_sent;
        const hasEmail = !!row.email;
        const numLabel = isUniversityType ? "학번" : "번호";
        const numVal = isUniversityType
          ? row.student_num || row.num || "N/A"
          : row.num || "N/A";

        // 1행: 인증코드 | 번호/학번 | 성명 (성별 / 생년월일)
        const row1 = h(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
              paddingBottom: "8px",
              borderBottom: "1px dashed #e8e8e8",
              fontSize: "13px",
            },
          },
          [
            // 인증코드
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, "인증코드:"),
                h(
                  "strong",
                  { style: { color: "#e03131", letterSpacing: "0.5px", fontSize: "14px" } },
                  row.authCode || "N/A"
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 번호 / 학번
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, `${numLabel}:`),
                h(
                  "span",
                  {
                    style: {
                      fontWeight: numVal !== "N/A" ? "bold" : "normal",
                      color: numVal !== "N/A" ? "#333" : "#999",
                    },
                  },
                  numVal
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 성명 및 인적사항
            h(
              "span",
              { style: { fontWeight: "bold", fontSize: "14px", color: "#1f2225" } },
              row.name || "N/A"
            ),
            h(
              "span",
              { style: { color: "#666" } },
              `(${common.getGenderString(row.gender)} / ${row.dob || "생년월일 미등록"})`
            ),
          ]
        );


        // 2행: 결과리포트 및 이메일 전송/수정 영역
        let row2;
        if (row.report_file) {
          let tooltipText = "전송완료";
          if (row.email_sent_at) {
            try {
              const d = new Date(row.email_sent_at);
              if (!isNaN(d.getTime())) {
                tooltipText = `${common.formatDateToYYYYMMDD2(d)} 전송됨`;
              }
            } catch {}
          }

          row2 = h(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "12px",
                paddingTop: "8px",
              },
            },
            [
              // 좌측: 이메일 정보 & 전송 상태
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" } },
                [
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "이메일:"),
                      h(
                        "span",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: row.email ? "500" : "normal",
                            color: row.email ? "#1f2225" : "#999",
                          },
                        },
                        row.email || "미등록"
                      ),
                      h(
                        NButton,
                        {
                          size: "tiny",
                          quaternary: true,
                          type: "primary",
                          onClick: () => showEmailEditDialog(row),
                        },
                        { default: () => "수정" }
                      ),
                    ]
                  ),
                  h("span", { style: { color: "#d9d9d9" } }, "|"),
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "전송상태:"),
                      isSent
                        ? h(
                            NTooltip,
                            { trigger: "hover" },
                            {
                              trigger: () =>
                                h(
                                  NTag,
                                  { type: "success", size: "small", round: true, style: "cursor: pointer;" },
                                  { default: () => "전송완료" }
                                ),
                              default: () => tooltipText,
                            }
                          )
                        : h(
                            NTag,
                            {
                              size: "small",
                              round: true,
                              bordered: false,
                              style: "color: #999; background: #f0f0f0;",
                            },
                            { default: () => "미전송" }
                          ),
                    ]
                  ),
                ]
              ),
              // 우측: 결과리포트 액션 버튼들
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "8px" } },
                [
                  h(
                    NButton,
                    {
                      strong: true,
                      tertiary: true,
                      size: "small",
                      disabled: isDoingJob.value,
                      loading: isDownloadingStudentReport.value[row.SK] || false,
                      onClick: () => downloadExamineeReportFile(row, isUniversityType),
                    },
                    { default: () => "리포트 다운로드" }
                  ),
                  h(
                    NTooltip,
                    { trigger: "hover" },
                    {
                      trigger: () =>
                        h(
                          NButton,
                          {
                            type: isSent ? "warning" : "info",
                            size: "small",
                            disabled: !hasEmail || isDoingJob.value,
                            loading: isSendingStudentEmail.value[row.SK],
                            onClick: () => doSendExamineeEmail(row, project),
                          },
                          { default: () => (isSent ? "이메일 재전송" : "이메일 전송") }
                        ),
                      default: () =>
                        !hasEmail
                          ? "이메일 주소를 입력해주세요"
                          : isSent
                          ? "결과리포트 이메일 재전송"
                          : "결과리포트 이메일 전송",
                    }
                  ),
                ]
              ),
            ]
          );
        } else if (row.is_report_generating) {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NButton,
                { strong: true, tertiary: true, size: "small", disabled: true, loading: true },
                { default: () => "결과리포트 생성 중..." }
              ),
            ]
          );
        } else {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NTag,
                { size: "small", bordered: false, style: "color: #999; background: #f7f7f7;" },
                { default: () => "진단 미완료 (결과리포트 생성 전)" }
              ),
            ]
          );
        }

        return h(
          "div",
          {
            style: {
              padding: "10px 14px",
              background: "#fafafa",
              borderRadius: "6px",
              border: "1px solid #f0f0f0",
            },
          },
          [row1, row2]
        );
      },
    },
  ];
};

const ExamineeTable: FunctionalComponent<ExamineeTableProps> = (props) => {
  const columns = createExamineeTableColumns(props.status, props.classType, props.project);
  return h(NDataTable, {
    columns: columns,
    data: props.examinees,
    bordered: false,
    singleLine: false,
    size: "small",
    style: { marginTop: "15px" },
  });
};

function triggerOrderProjectsUpdate() {
  if (orderProjectEntries.value) {
    orderProjectEntries.value = orderProjectEntries.value.map((p) => ({
      ...p,
      examinees: p.examinees ? [...p.examinees] : [],
    }));
  }
}

function showEmailEditDialog(examinee: Examinee) {
  const newEmailRef = ref<string>(examinee.email || "");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const d = dialog.create({
    title: "학생 이메일 수정",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        h("p", `"${examinee.name}" 학생의 이메일 주소를 입력해주세요.`),
        h(NInput, {
          value: newEmailRef.value,
          placeholder: "example@email.com",
          onUpdateValue: (value: string) => {
            newEmailRef.value = value;
          },
        }),
      ]),
    positiveText: "저장",
    negativeText: "취소",
    onPositiveClick: () => {
      const emailVal = newEmailRef.value.trim();
      if (!emailVal || !emailRegex.test(emailVal)) {
        message.error("올바른 이메일 형식을 입력해주세요.");
        return false;
      }
      d.loading = true;
      updateExamineeEmailCallable({
        examineeSK: examinee.SK,
        email: emailVal,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            examinee.email = emailVal;
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 수정되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 수정 실패",
              description: common.getResultError(res) || "이메일 수정에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 수정 중 오류가 발생했습니다.",
            duration: 3000,
          });
        });

      return false;
    },
  });
}


function doSendExamineeEmail(examinee: Examinee, project: Project | undefined) {
  if (!project) return;
  if (!examinee.email) {
    message.warning("학생의 이메일 주소가 등록되지 않았습니다.");
    return;
  }
  if (!examinee.report_file) {
    message.warning("결과리포트가 아직 생성되지 않았습니다.");
    return;
  }

  const isResend = !!examinee.email_sent;
  const d = dialog.create({
    title: isResend ? "결과리포트 이메일 재전송" : "결과리포트 이메일 전송",
    type: isResend ? "warning" : "info",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        isResend
          ? h("p", { style: "color: #e6a23c; font-weight: bold;" }, "이미 이메일이 전송된 학생입니다.")
          : null,
        h(
          "p",
          `"${examinee.name}" 학생(${examinee.email})에게 결과리포트 이메일을 ${isResend ? "다시 " : ""}전송하시겠습니까?`
        ),
      ]),
    positiveText: "전송",
    negativeText: "취소",
    onPositiveClick: () => {
      d.loading = true;
      isSendingStudentEmail.value[examinee.SK] = true;
      sendExamineeReportEmailCallable({
        projectSK: project.SK,
        examineeSK: examinee.SK,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            const payload = res.data?.data || res.data || {};
            examinee.email_sent = true;
            examinee.email_sent_at = payload.email_sent_at || new Date().toISOString();
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 전송되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 전송 실패",
              description: common.getResultError(res) || "이메일 전송에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 전송 중 오류가 발생했습니다.",
            duration: 3000,
          });
        })
        .finally(() => {
          isSendingStudentEmail.value[examinee.SK] = false;
        });

      return false;
    },
  });
}




async function doOpenProject(projectSK: string) {
  isDoingJob.value = true;
  isProjectOpening.value[projectSK] = true;
  try {
    const result = await openOneProjectCallable({ SK: projectSK });
    if (common.evalFunctionResult(result)) {
      notification.warning({
        title: "요청 성공",
        description: "검사 오픈 요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "검사 오픈 요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "검사 오픈 요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isProjectOpening.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function downloadTeacherReportFile(projectItem: Project) {
  pageLoading.value = true;
  let filename = "";
  if (projectItem.type == "putt_u" || projectItem.type == "tec") {
    filename = `${projectItem.major}_${projectItem.class}학년.xlsx`;
  } else {
    filename = `${projectItem.grade}학년_${projectItem.class}반.xlsx`;
  }
  await downloadReportFile(projectItem.teacher_report_file, filename);
  pageLoading.value = false;
}
async function downloadExamineeReportFile(
  examineeItem: Examinee,
  isUniversityType: boolean
) {
  isDoingJob.value = true;
  isDownloadingStudentReport.value[examineeItem.SK] = true;
  const numStr = isUniversityType ? examineeItem.student_num : examineeItem.num;
  const projectType = orderProjectEntries.value
    ? orderProjectEntries.value[activeClassIndex.value].type
    : "";
  let typePrefix = "";
  if (projectType) {
    typePrefix = projectType.split("_")[0].toUpperCase() + "-";
  }
  let filename = `${typePrefix}${numStr}_${examineeItem.name}.pdf`;
  await downloadReportFile(examineeItem.report_file, filename);
  isDownloadingStudentReport.value[examineeItem.SK] = false;
  isDoingJob.value = false;
}

async function doRequestTeacherReport(projectSK: string) {
  isDoingJob.value = true;
  isTeacherReporting.value[projectSK] = true;
  try {
    const result = await requestTeacherReportGenerationCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value] && orderProjectEntries.value[activeClassIndex.value].SK === projectSK) {
        orderProjectEntries.value[activeClassIndex.value].is_teacher_report_generating = true;
      }
      notification.warning({
        title: "요청 성공",
        description: "결과리포트_담임용 생성요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) ||
          "결과리포트_담임용 생성요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "결과리포트_담임용 생성요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isTeacherReporting.value[projectSK] = false;
    isDoingJob.value = false;
  }
}
async function doRequestExamineeReport(projectSK: string) {
  isDoingJob.value = true;
  isStudentReporting.value[projectSK] = true;
  try {
    const result = await requestProjectReportGenerationCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      const skList = result.data.data;
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value] && orderProjectEntries.value[activeClassIndex.value].SK === projectSK) {
        const examinees = orderProjectEntries.value[activeClassIndex.value].examinees;
        if (examinees && skList && Array.isArray(skList)) {
          examinees.forEach(examinee => {
            if (skList.includes(examinee.SK)) {
              examinee.is_report_generating = true;
            }
          });
        }
      }
      notification.warning({
        title: "요청 성공",
        description: "결과리포트_학생용 생성요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) ||
          "결과리포트_학생용 생성요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "결과리포트_학생용 생성요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isStudentReporting.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function doRequestProjectClose(projectSK: string) {
  showActionDialog({
    title: "확인",
    content: () =>
      h("div", null, [
        h(
          "p",
          { style: { color: "red", fontWeight: "bold" } },
          "정말로 검사를 종료하시겠습니까?"
        ),
        h("p", "검사를 종료하면 되돌릴 수 없으며, 리포트 생성이 불가능합니다."),
      ]),
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "default" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      isDoingJob.value = true;
      isProjectClosing.value[projectSK] = true;
      try {
        const result = await closeOneProjectCallable({
          SK: projectSK,
        });
        if (common.evalFunctionResult(result)) {
          notification.warning({
            title: "요청 성공",
            description: "검사 종료 및 이메일 전송요청이 성공 했습니다.",
            duration: 3000,
          });
        } else {
          notification.error({
            title: "요청 실패",
            description:
              common.getResultError(result) ||
              "검사 종료 및 이메일 전송요청이 실패 했습니다.",
            duration: 3000,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "요청 실패",
          description: error || "검사 종료 및 이메일 전송요청이 실패 했습니다.",
          duration: 3000,
        });
      } finally {
        isProjectClosing.value[projectSK] = false;
        isDoingJob.value = false;
      }
    },
  });
}
async function scrollToClass(index: number) {
  if (
    !orderProjectEntries.value ||
    index < 0 ||
    index >= orderProjectEntries.value.length
  ) {
    return; // 유효하지 않은 인덱스 처리
  }
  activeClassIndex.value = index;

  const targetProject = orderProjectEntries.value[index];
  if (targetProject && targetProject.SK) {
    await fetchSingleProjectDetails(targetProject.SK, index);
  }
}

// 진단 type에 따라 그룹화된 항목들을 반환하는 computed 속성
const groupedProjectEntries = computed(() => {
  const groups: {
    type: string;
    title: string;
    entries: (Project & { originalIndex: number })[];
  }[] = [];
  const typeMap: { [type: string]: (Project & { originalIndex: number })[] } =
    {};

  orderProjectEntries.value?.forEach((entry, originalIndex) => {
    if (!typeMap[entry.type]) {
      typeMap[entry.type] = [];
    }
    typeMap[entry.type].push({ ...entry, originalIndex });
  });

  // Map 객체를 배열로 변환하고, 각 그룹에 제목 추가
  for (const type in typeMap) {
    if (Object.prototype.hasOwnProperty.call(typeMap, type)) {
      // 정렬 로직 추가: 학년(grade) 올림차순 -> 반(class) 올림차순
      typeMap[type].sort((a, b) => {
        const gradeA = String(a.grade || "");
        const gradeB = String(b.grade || "");

        if (gradeA !== gradeB) {
          return gradeA.localeCompare(gradeB, undefined, { numeric: true });
        }

        const classA = String(a.class || "");
        const classB = String(b.class || "");
        return classA.localeCompare(classB, undefined, { numeric: true });
      });

      groups.push({
        type: type,
        title: common.getProjectName(type), // 그룹 제목을 가져오는 함수 사용
        entries: typeMap[type],
      });
    }
  }
  return groups; // 필요시 여기서 그룹 순서를 정렬할 수 있습니다.
});

function getOriginalIndex(item: Project & { originalIndex?: number }): number {
  if (item.originalIndex !== undefined) {
    return item.originalIndex;
  }
  return (
    orderProjectEntries.value?.findIndex((entry) => entry.SK === item.SK) ?? -1
  );
}

function getClassItemTitle(
  classItem: Project & { originalIndex?: number }
): string {
  const isUniversityType =
    classItem.type === "putt_u" || classItem.type === "tec";
  if (isUniversityType) {
    return `${classItem.major} ${classItem.grade}`;
  } else {
    return `${classItem.grade}학년 ${classItem.class}반`;
  }
}
function handleCancel() {
  router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
}

function getOrgId() {
  const localAuth = common.getLocalAuth();
  if (localAuth && "orgId" in localAuth && localAuth.orgId) {
    return localAuth.orgId;
  }
  const orderSKFromRoute = route.params.SK as string;
  if (orderSKFromRoute) {
    const parts = orderSKFromRoute.split("#");
    if (parts[0] === "org" && parts[1] === "org") {
      return parts[2];
    } else if (parts[0] === "org") {
      return parts[1];
    }
  }
  return "";
}

async function openManagerSelectModalForDetail() {
  isManagerModalOpen.value = true;
  loadingMembers.value = true;
  orgMembers.value = [];
  memberSearchQuery.value = "";
  isIncludeAdmin.value = false;
  try {
    const orgId = getOrgId();
    if (!orgId) {
      notification.error({
        title: "오류",
        description: "기관 식별자를 찾을 수 없습니다.",
        duration: 3000,
      });
      return;
    }
    const result = await getOrgMembersCallable({ orgId });
    const list = common.getItemListFromFunctionResult(result) || [];
    orgMembers.value = list;
  } catch (error) {
    console.error("기관 멤버 조회 실패:", error);
    notification.error({
      title: "오류",
      description: "기관 멤버 정보를 불러오는데 실패했습니다.",
      duration: 3000,
    });
  } finally {
    loadingMembers.value = false;
  }
}

async function selectManager(row: any) {
  if (!orderProjectEntries.value || !orderProjectEntries.value[activeClassIndex.value]) {
    return;
  }
  const project = orderProjectEntries.value[activeClassIndex.value];
  const managerId = row.SK.split("#").pop() || "";

  isUpdatingManager.value = true;
  try {
    const params = {
      SK: project.SK,
      email: row.email,
      manager_name: row.name,
      manager_role: row.role || "",
      manager_position: row.position || "",
      manager_id: managerId,
    };
    const result = await updateProjectManagerCallable(params);
    if (common.evalFunctionResult(result)) {
      project.email = row.email;
      project.manager_name = row.name;
      project.manager_role = row.role || "";
      project.manager_position = row.position || "";
      project.manager_id = managerId;
      
      notification.success({
        title: "성공",
        description: "담당자가 정상적으로 변경되었습니다.",
        duration: 3000,
      });
      isManagerModalOpen.value = false;
    } else {
      notification.error({
        title: "실패",
        description: common.getResultError(result) || "담당자 변경에 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("담당자 변경 오류:", error);
    notification.error({
      title: "오류",
      description: error || "담당자 변경 처리 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    isUpdatingManager.value = false;
  }
}
</script>

<style scoped>
.main_div {
  background-color: #f0f2f5;
  min-height: calc(100vh - var(--header-height, 64px));
  padding: 1px; /* 자식 마진 병합 방지 */
}
.personal-order-project-detail .body_content.sub {
  display: flex;
  gap: 10px;
  padding: 0 10px !important;
}

.split-view-container {
  display: flex;
  width: 100%;
  gap: 10px;
}

.left-class-list {
  flex: 0 0 200px;
  max-width: 250px;
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.07);
  overflow-y: auto;
  min-height: 550px; /* 최소 높이 추가 (예시 값) */
  max-height: calc(100vh - 250px); /* 예: 50px 늘림 */
}

.list-title {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
}

.left-class-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.content_delimiter_line {
  height: 1px;
  width: 100%;
  background-color: #efeff5;
  margin-top: 15px;
  margin-bottom: 25px;
}

.left-class-list .list-item {
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 1px dashed #eee;
  font-size: 0.95em;
  color: #555;
  transition: color 0.2s, font-weight 0.2s;
}

.left-class-list .list-item:last-child {
  border-bottom: none;
}

.left-class-list .list-item:hover {
  color: #000;
  font-weight: bold;
}

.left-class-list .list-item.active {
  color: #007bff; /* 활성 항목 색상 */
  font-weight: bold;
}
.list-subtitle {
  font-size: 1em;
  font-weight: bold;
  margin-top: 10px; /* 이전 그룹과의 간격 */
  margin-bottom: 5px; /* 하위 목록과의 간격 */
  padding: 5px 8px; /* 내부 여백 */
  background-color: #f0f2f5; /* 배경색 추가 */
  border-radius: 4px; /* 모서리 둥글게 */
  color: #333; /* 글자색 조정 */
}
.form-section-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 2px solid #007bff; /* 섹션 구분선 강조 */
  padding-bottom: 10px;
}

.right-details-area {
  flex-grow: 1;
  overflow-y: auto;
  min-height: 550px; /* 최소 높이 추가 (예시 값) */
  max-height: calc(100vh - 250px); /* 예: 50px 늘림 */
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.07);
}

.class-info-section {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}
.class-info-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 15px;
  color: #444;
}

.examinee-creation-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px dashed #ccc;
}
.examinee-creation-title {
  font-size: 1.05em;
  font-weight: bold;
  margin-bottom: 15px;
  color: #555;
}
.examinee-section-title {
  font-size: 1.05em;
  font-weight: bold;
  margin-bottom: 15px; /* 테이블과의 간격 */
  color: #555;
}
.examinee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* 학생 제목과 폼 아이템 사이 간격 */
}
.examinee-number-title {
  font-size: 1em; /* 기존 h6보다 약간 크게 조정 */
  font-weight: 600; /* 약간 더 굵게 */
  color: #333;
}
.quantity-item :deep(.n-descriptions-item-label),
.quantity-item :deep(.n-descriptions-item-content) {
  font-size: 0.85em; /* 레이블과 내용의 폰트 크기를 줄임 */
  padding-top: 6px; /* 패딩 조절 */
  padding-bottom: 6px; /* 패딩 조절 */
}
/* NFormItemGi for display */
:deep(.n-form-item .n-form-item-label) {
  color: #555; /* Adjust label color if needed */
  font-weight: normal; /* Adjust label weight if needed */
}
:deep(.n-form-item .n-form-item-blank) {
  color: #333; /* Adjust content color if needed */
}
.right-details-area .n-card {
  /* .right-details-area에 padding이 생겼으므로, NCard의 자체 마진은 제거하거나 조정합니다. */
  margin-bottom: 0 !important; /* 카드가 여러 개일 경우를 대비해 하단 마진만 남기거나, 모두 0으로 */
  box-shadow: none !important; /* 부모에 그림자가 있으므로 카드 자체 그림자는 제거 */
  border: none !important; /* 부모에 테두리가 있으므로 카드 자체 테두리는 제거 */
}
</style>
